import service from './request.js';
import BASE_URL from './api.js';
// 验证码登录
export function loginMobile(parmas) { 
    return service.post(`${BASE_URL}/login/mobilejl`, parmas)
}

// 发送验证码
export function captchaVerify(parmas) {
    return service.post(`${BASE_URL}/captcha/verifyjl`, parmas)
}

// 密码登录
export function loginPassword(parmas) { 
    return service.post(`${BASE_URL}/login/passwordjl`, parmas)
}